import { frontendURL } from '../../../helper/URLHelper';
import HelpCenter from './HelpCenterEmbed.vue';

/**
 * Rota interna da Central de Ajuda. A pagina renderiza um iframe que carrega
 * `https://ajuda.siteup.com.br` em modo embed, mantendo o usuario dentro do
 * dashboard SiteUp sem precisar abrir nova aba.
 */
export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/help-center'),
      name: 'help_center_index',
      meta: {
        permissions: ['administrator', 'agent'],
      },
      component: HelpCenter,
    },
  ],
};
